<template>
  <div style="background-color: white; padding: 16px;">
    <h3 style="text-transform: uppercase; margin-bottom: 12px;">
      Update Ad Listing
    </h3>
    <property-form
      v-if="campaignType === 'Property' || campaignType === 'Property Extend'"
      :campaignId="campaignId"
    />
    <office-form
      v-else-if="campaignType === 'Office'"
      :campaignId="campaignId"
    />
    <agency-form
      v-else-if="campaignType === 'Agent'"
      :campaignId="campaignId"
    />
    <agent-extend-form
      v-else-if="campaignType === 'Agent Extend'"
      :campaignId="campaignId"
    />
    <property-form
      v-else-if="campaignType === 'Property Just Sold'"
      :campaignId="campaignId"
    />
  </div>
</template>
<script>
import PropertyForm from './PropertyForm.vue';
import OfficeForm from './OfficeForm.vue';
import AgencyForm from './AgencyForm.vue';
import AgentExtendForm from './AgentExtendForm.vue';

export default {
  props: ['campaignId', 'campaignType'],
  components: {
    PropertyForm,
    OfficeForm,
    AgencyForm,
    AgentExtendForm,
  },
};
</script>

<style scoped>
.validation-error-message {
  font-size: 14px;
  color: red;
}
</style>
